import { AppState } from '../models/app-state.model';
import { Card } from '../models/card.model';
import { Category } from '../models/category.model';

export function isCategory(obj: any): obj is Category {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    typeof obj.id === 'string' &&
    typeof obj.name === 'string' &&
    typeof obj.color === 'string' &&
    typeof obj.isSystem === 'boolean'
  );
}

export function isCard(obj: any): obj is Card {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    typeof obj.id === 'string' &&
    typeof obj.title === 'string' &&
    typeof obj.categoryId === 'string' &&
    'status' in obj
  );
}

export function isAppState(obj: any): obj is AppState {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    typeof obj.schemaVersion === 'number' &&
    typeof obj.savedAt === 'string' &&
    Array.isArray(obj.categories) &&
    Array.isArray(obj.cards) &&
    obj.ladder !== undefined &&
    obj.ladder !== null &&
    Array.isArray(obj.ladder.levels) &&
    obj.ui !== undefined &&
    obj.ui !== null
  );
}
